import { TYPES } from '../../common/constants';

export const setValidation = (payload) => ({
    type:TYPES.SET_VALIDATION,
    payload
  })
  
  export const clearValidation = () => ({
    type: TYPES.CLEAR_VALIDATION
  })
  